import { render, staticRenderFns } from "./Hora.vue?vue&type=template&id=3d5b332a&lang=true"
import script from "./Hora.vue?vue&type=script&lang=js"
export * from "./Hora.vue?vue&type=script&lang=js"
import style0 from "./Hora.vue?vue&type=style&index=0&id=3d5b332a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports